module.exports = __webpack_public_path__ + "img/jylnicon1.89a93752.jpg";